var map = {
	"./ws-button.vue": 5397,
	"./ws-cart.vue": 72,
	"./ws-error-page.vue": 5382,
	"./ws-fulfilment-slots-modal.vue": 8494,
	"./ws-image.vue": 7625,
	"./ws-index.vue": 1703,
	"./ws-input.vue": 3830,
	"./ws-menu-product-card.vue": 715,
	"./ws-menu-product-modal.vue": 191,
	"./ws-modal.vue": 8717,
	"./ws-product-image.vue": 8859,
	"./ws-quantity-buttons.vue": 3306,
	"./ws-search-button-input.vue": 4055,
	"./ws-shop-closed.vue": 2961,
	"./ws-simple-page.vue": 9377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3314;